import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import type { Locale } from '@onefootprint/request-types';
import { LinkButton } from '@onefootprint/ui';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CitizenshipField } from './citizenship-field';
type CitizenshipFieldsProps = {
  locale: Locale;
  disabled?: boolean;
};
export const CitizenshipFields = t0 => {
  const $ = _c(24);
  const {
    locale,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.fields.usLegalStatus.citizenship"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const {
    control
  } = useFormContext();
  let t2;
  if ($[1] !== control) {
    t2 = {
      name: "citizenships",
      control
    };
    $[1] = control;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    append,
    fields,
    remove
  } = useFieldArray(t2);
  const t3 = `citizenships.${fields.length - 1}.value`;
  let t4;
  if ($[3] !== control || $[4] !== t3) {
    t4 = {
      control,
      name: t3
    };
    $[3] = control;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const lastCitizenship = useWatch(t4);
  let t5;
  if ($[6] !== append || $[7] !== disabled || $[8] !== fields || $[9] !== lastCitizenship || $[10] !== locale || $[11] !== remove || $[12] !== t) {
    let t6;
    if ($[14] !== append || $[15] !== disabled || $[16] !== fields.length || $[17] !== lastCitizenship || $[18] !== locale || $[19] !== remove || $[20] !== t) {
      t6 = (citizenshipField, index) => {
        const fieldName = `citizenships.${index}.value` as const;
        const isLastCitizenship = index === fields.length - 1;
        const correctNumCitizenships = !disabled && lastCitizenship && lastCitizenship !== "US" && fields.length < 3;
        return <div key={citizenshipField.id} data-dd-privacy="mask" className="flex flex-col gap-2"><CitizenshipField name={fieldName} locale={locale} hasDeleteButton={fields.length > 1} onDelete={() => remove(index)} disabled={disabled} />{isLastCitizenship && correctNumCitizenships && <LinkButton iconComponent={IcoPlusSmall16} iconPosition="left" onClick={() => append({
            label: "",
            value: undefined
          })} data-testid="add-citizenship-button">{t(_temp)}</LinkButton>}</div>;
      };
      $[14] = append;
      $[15] = disabled;
      $[16] = fields.length;
      $[17] = lastCitizenship;
      $[18] = locale;
      $[19] = remove;
      $[20] = t;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t5 = fields.map(t6);
    $[6] = append;
    $[7] = disabled;
    $[8] = fields;
    $[9] = lastCitizenship;
    $[10] = locale;
    $[11] = remove;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[22] !== t5) {
    t6 = <>{t5}</>;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};
function _temp($) {
  return $.addText;
}